/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  getters: {
    directories: state => Object.keys(state.directories).map(k => state.directories[k]),
    directoryCount: state => Object.keys(state.directories).length,
    recordCount: state => state.total_records.toLocaleString(),
    facets: state => (directory) => {
      /* eslint-disable prefer-destructuring */
      const fields = state.directories[directory].fields;
      const filteredFields = Object.keys(fields)
        .filter(f => fields[f].facet === true);
      return filteredFields.reduce((r, k) => r.concat(fields[k]), []);
    },
    links: state => (directory) => {
      /* eslint-disable prefer-destructuring */
      const fields = state.directories[directory].fields;
      const filteredFields = Object.keys(fields)
        .filter(f => fields[f].type === 'link');
      return filteredFields.reduce((r, k) => r.concat(fields[k]), []);
    },
  },
  mutations: {
    POPULATE_MARKER(state, m) {
      /* eslint-disable no-param-reassign */
      state.markers[`m${m.mapMarker.metadata.id}`] = m.mapMarker;
      state.markers[`m${m.mapMarker.metadata.id}`].info = m.mapMarkerInfo;
    },
    CLEAR_MARKERS(state) {
      state.markers = {};
    },
    ADD_TOTAL_RECORDS(state, total) {
      state.total_records += total;
    },
    SETUP(state, file) {
      Object.assign(state, file);
    },
  },
  actions: {
    populateMarker({ commit }, marker) {
      commit('POPULATE_MARKER', marker);
    },
    resetMarkers({ commit, state }) {
      Object.keys(state.markers).forEach((index) => {
        state.markers[index].setMap(null);
      });
      commit('CLEAR_MARKERS');
    },
    getRecordCount({ commit, state }) {
      state.total_records = 0;
      Object.keys(state.directories).forEach((dir) => {
        fetch(`https://status.algolia.com/1/usage/records/period/day/${state.directories[dir].algolia_index}`, {
          headers: {
            'X-Algolia-Application-Id': state.algolia_app_id,
            'X-Algolia-API-Key': state.algolia_monitoring_api_key,
          },
        }).then(response => response.json())
          .then((json) => {
            commit('ADD_TOTAL_RECORDS', json.records.slice(-1).pop().v);
          });
      });
    },
    populate({ commit }, file) {
      commit('SETUP', file);
    },
  },
});
